package com.tedd.db

import kotlin.String

public data class SelectLinks(
  public val id: String,
  public val url: String?,
)
